import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { BODY_SKINS } from "../helpers/consts";

const STAND_STILL_IN_TELEPORT_ENTRANCE_FRAMES = 8;

export class TeleportPlacement extends Placement {
  givesPreAutoMoveFrames(forBody) {
    if (forBody.isImmuneToTeleport) {
      return 0;
    }
    //Stand in the teleport for a moment before teleporting
    return STAND_STILL_IN_TELEPORT_ENTRANCE_FRAMES;
  }

  changeHeroSkinOnCollide() {
    return BODY_SKINS.TELEPORT;
  }

  teleportsToPositionOnUnlock(forBody) {
    //Get all teleports
    const allTeleports = this.level.placements.filter((p) => {
      return p.type === this.type;
    });

    //Only 1, so do not teleport (already at the one)
    if (allTeleports.length === 1) {
      return null;
    }

    //Try to use the next one... default to first in list if we are at the end
    const myIndex = allTeleports.findIndex((p) => p.id === this.id);
    const match = allTeleports[myIndex + 1] ?? allTeleports[0];
    return {
      x: match.x,
      y: match.y,
    };
  }

  renderComponent() {
    return <Sprite frameCoord={this.level.animatedTiles.teleportFrame} />;
  }
}
